import { SortDirection, ColumnType } from 'utils/shared/trades/types';
import { TimeframeOption } from './TimeframeToggle';

export enum LevelsTimeframe {
  Week = 'WEEK',
  Month = 'MONTH',
}

export const LEVELS_TIMEFRAME_OPTIONS: TimeframeOption[] = [
  { value: LevelsTimeframe.Week, label: 'Week' },
  { value: LevelsTimeframe.Month, label: 'Month' },
];
export const DEFAULT_LEVELS_TIMEFRAME = LevelsTimeframe.Week;

export interface LevelsHeaderProps {
  aggregateSortKey: string;
  setAggregateSortKey: (key: string) => void;
  aggregateSortDirection: SortDirection;
  setAggregateSortDirection: (direction: SortDirection) => void;
  ticker: string;
  minStrength: number;
  setMinStrength: (n: number) => void;
  query: string;
  setQuery: (q: string) => void;
  timeframe: string;
  setTimeframe: (timeframe: string) => void;
}

export interface LevelProps {
  ticker: string;
}

export const DEFAULT_AGGREGATE_KEY_INDEX = 0;
export const LEVELS_TABLE_HEADERS = [
  { name: 'Level', sortKey: 'price', columnType: ColumnType.Number },
  { name: 'Prints', sortKey: 'prints', columnType: ColumnType.Number },
  { name: 'Size', sortKey: 'volume', columnType: ColumnType.Number },
  { name: 'Premium', sortKey: 'amount', columnType: ColumnType.Number },
  { name: 'Strength', sortKey: 'strength', columnType: ColumnType.Number },
];
export const DEFAULT_LEVELS_KEY = LEVELS_TABLE_HEADERS[DEFAULT_AGGREGATE_KEY_INDEX].sortKey;
